/**
 * Dynamically position hero bg according to data-values
 * If no value is set, the hero background element gets substracted by 1/3 of the elements height including padding
 * Setting [data-bg-anchor='{ "direction": "center|bottom|top" }'} adds the ability to control the offset
 *
 * @param [data-bg-anchor]
 */

import _throttle from 'lodash.throttle'

const heroElement = document.querySelector('.c-hero--has-bg')

const setHeroBgHeight = () => {
  const bgAnchorElement = heroElement.querySelector('[data-bg-anchor]')

  if (bgAnchorElement) {
    const bgAnchorBox = bgAnchorElement.getBoundingClientRect()
    const {bgAnchor} = bgAnchorElement.dataset
    heroElement.classList.add('c-hero--has-dynamic-bg')

    if (bgAnchor) {
      let bgAnchorElementPos = 0
      const bgAnchorObject = JSON.parse(bgAnchor)
      if (bgAnchorObject.direction === 'center') {
        bgAnchorElementPos = bgAnchorBox.bottom - bgAnchorBox.height / 2
      } else {
        bgAnchorElementPos = bgAnchorBox[bgAnchorObject.direction]
      }

      const heroElementStyle = getComputedStyle(heroElement)
      const height = heroElement.getBoundingClientRect().bottom - parseInt(heroElementStyle.paddingBottom, 10) - bgAnchorElementPos

      heroElement.style.setProperty('--bg-height-offset', `${height}px`)
    } else {
      heroElement.style.setProperty('--bg-height-offset', `${bgAnchorBox.height / 3}px`)
    }
  }
}

if (heroElement) {
  setHeroBgHeight()
  window.addEventListener('resize', _throttle(() => setHeroBgHeight(), 500))
}


const headerLogo = document.querySelector('.c-logo__icon');
const heroImage = document.querySelector('.c-hero--top-default .c-hero__image');

const setTopLevelImage = () => {

  const mq = window.matchMedia('(min-width: 1024px)')
  if (mq.matches === true) {
    const logoPos = headerLogo.getBoundingClientRect();
    heroImage.style.marginLeft = logoPos.right + 'px';
  } else {
    heroImage.style.marginLeft = '';
  }
}

if (heroImage && headerLogo) {
  setTopLevelImage()
  window.addEventListener('resize', _throttle(() => setTopLevelImage(), 50))
}
